import {observable, action, computed} from 'mobx';
import {t} from 'shared/core';
import {DomainObject, oneOf} from 'shared/store';
import Employee from '../employees/Employee';
import CompanyDocument from './CompanyDocument';

class AssignmentRule extends DomainObject {
  @observable assigneeType;
  @observable employee;
  @observable orderOffset;
  @observable companyDocument;
  @observable order;
  @observable color;

  @action merge(other) {
    super.merge(other, {
      employee: Employee,
      companyDocument: CompanyDocument,
      assigneeType: oneOf(['employee', 'manager', 'specific_employee'])
    });
  }

  @computed get assignee() {
    if (this.isSpecificEmployee) return this.employee.id;

    return this.assigneeType;
  }

  @computed get name() {
    if (this.isSpecificEmployee) return this.employee.name;

    return t(`models.company_document.assignment_rules.${this.assigneeType}`);
  }

  @computed get nameWithOrder() {
    // this is temporary
    if (this.isEmployee) return `1. ${this.name}`;

    return `${this.order + this.orderOffset}. ${this.name}`;
  }

  @computed get isSpecificEmployee() {
    return this.assigneeType === 'specific_employee';
  }

  @computed get isEmployee() {
    return this.assigneeType === 'employee';
  }

  @computed get isRemovable() {
    return !this.isEmployee;
  }
}

export default AssignmentRule;
